import { render, staticRenderFns } from "./ProductListingV2.vue?vue&type=template&id=a3d30232&"
import script from "./ProductListingV2.vue?vue&type=script&lang=js&"
export * from "./ProductListingV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports